import React, { useState } from 'react';
import { Header } from '../../components/feature/Header';
import { HeroSection } from './components/HeroSection';
import { PropertyCategories } from './components/PropertyCategories';
import { Footer } from './components/Footer';

const HomePage: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState('boats');

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection setActiveCategory={setActiveCategory} />
        <div id="property-categories">
          <PropertyCategories initialCategory={activeCategory} />
        </div>
        {/* Experiences section removed as requested */}
        <div id="contact">
          <Footer />
        </div>
      </main>
    </div>
  );
};

export default HomePage;